import { useCallback } from 'react';
import { MemberUser } from '@youhelp-ru/core';
import { useCurrentUser } from '../../currentUser/@x/dialog';
import { coreDialogApi } from '../api';
import { mapUserToMemberUser } from '../lib';

export const useMarkMessageAsRead = (dialogId: number, messageId: number) => {
  const currentViewer = useCurrentUser();
  const [markMessageRead] = coreDialogApi.useMarkReadMutation();

  return useCallback(
    async (currentMember?: MemberUser | null) => {
      const realUser = mapUserToMemberUser(currentViewer);
      const as = realUser && currentMember && !MemberUser.isEqual(currentMember, realUser) ? currentMember : null;
      await markMessageRead({ messageId, dialogId, as });
    },
    [currentViewer, dialogId, markMessageRead, messageId],
  );
};
